let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eoWBf")).then(() => parcelRequire('kKnR9'));